import React, { FunctionComponent, memo, SyntheticEvent } from 'react'

import { PublicInput } from './atoms'

interface Props {
  type?: 'text' | 'password' | 'tel'
  hasError?: boolean
  id: string
  value: string
  disablePaste?: boolean
}

const PublicTextInput: FunctionComponent<Props> = ({ type = 'text', hasError, id, disablePaste, ...rest }) => {
  const handleDisablePaste = (event: SyntheticEvent): void => event.preventDefault()

  return (
    <PublicInput
      id={id}
      type={type}
      error={hasError ? hasError : undefined}
      autoComplete="off"
      onPaste={disablePaste ? handleDisablePaste : undefined}
      {...rest}
    />
  )
}

PublicTextInput.displayName = 'PublicTextInput'

export default memo(PublicTextInput)
